var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{attrs:{"id":"lgc__header-c"}},[_c('CardLayoutLogo'),_c('CardLayoutTitle',[_vm._v(" Entre na sua conta ")]),_c('CardLayoutSubtitle',[_vm._v(" Por favor, insira seu e-mail e senha para acessar a conta ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }